import List from './list'
import Detail from './detail'
import Dealer from './dealer'
import Create from './create'

export default function(prefix, app) {
  return app
    .useRoute(`${prefix}/list/detail/:id`, Detail)
    .useRoute(`${prefix}/list/create`, Create)
    .useRoute(`${prefix}/list`, List)
    .useRoute(`${prefix}/dealer`, Dealer)
}
